import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link, type LinkProps } from "react-router-dom";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand-mark" aria-label="幻视PPT">
      <img className="brand-logo" src="/assets/brand/huanshi-ppt-logo.png" alt="" aria-hidden="true" />
      {!compact && <span className="brand-name">幻视<span>PPT</span></span>}
    </span>
  );
}

export function Button({ variant = "primary", className = "", ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "secondary" | "ghost" | "danger" }) {
  return <button className={`button button-${variant} ${className}`} {...props} />;
}

export function ButtonLink({ variant = "primary", className = "", ...props }: LinkProps & { variant?: "primary" | "secondary" | "ghost" }) {
  return <Link className={`button button-${variant} ${className}`} {...props} />;
}

export function Badge({ children, tone = "neutral" }: { children: ReactNode; tone?: "neutral" | "brand" | "success" | "warning" | "danger" }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

export function Icon({ name }: { name: "home" | "plus" | "files" | "spark" | "user" | "settings" | "chart" | "users" | "flask" | "palette" | "logout" }) {
  const paths: Record<string, string> = {
    home: "M3 11.5 12 4l9 7.5V21h-6v-6H9v6H3z",
    plus: "M12 5v14M5 12h14",
    files: "M6 3h9l3 3v15H6zM9 10h6M9 14h6",
    spark: "m12 2 1.7 5.3L19 9l-5.3 1.7L12 16l-1.7-5.3L5 9l5.3-1.7z",
    user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 9a7 7 0 0 1 14 0",
    settings: "M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-11v2m0 11v2m7.5-7.5h-2m-11 0h-2m12.8-5.3-1.4 1.4M8.1 15.9l-1.4 1.4m10.6 0-1.4-1.4M8.1 8.1 6.7 6.7",
    chart: "M4 20V10m6 10V4m6 16v-7m4 7H2",
    users: "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm8-1a3 3 0 1 0 0-6m-15 16a7 7 0 0 1 14 0m1-5a5 5 0 0 1 5 5",
    flask: "M9 3h6m-5 0v6l-5 9a2 2 0 0 0 1.8 3h10.4A2 2 0 0 0 19 18l-5-9V3m-6 12h8",
    palette: "M12 3a9 9 0 0 0 0 18h1.5a2.5 2.5 0 0 0 0-5H12a2 2 0 0 1 0-4 0c0-1.1.9-2 2-2h2a9 9 0 0 0 0-18ZM7.5 9h.01M10 6.5h.01M15 7h.01M17 11h.01",
    logout: "M10 5H5v14h5m4-3 4-4-4-4m4 4H9",
  };
  return <svg className="icon" viewBox="0 0 24 24" aria-hidden><path d={paths[name]} /></svg>;
}

export function PageTitle({ eyebrow, title, description, action }: { eyebrow?: string; title: string; description?: string; action?: ReactNode }) {
  return (
    <header className="page-title">
      <div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h1>{title}</h1>{description && <p>{description}</p>}</div>
      {action && <div>{action}</div>}
    </header>
  );
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return <div className="empty-state"><div className="empty-visual"><span /><span /><span /></div><h3>{title}</h3><p>{description}</p>{action}</div>;
}

export function LoadingBlock() {
  return <div className="loading-grid" aria-label="加载中">{[1, 2, 3].map((item) => <div className="skeleton" key={item} />)}</div>;
}
